import { Service, PackageTemplate } from "@raskrask-dk/raskrask-utils";
import type {IPackageDTO} from "..";

export class PackageMapper {
  constructor(private packageConstructor: (packageDTO: IPackageDTO, service: Service) => PackageTemplate) {}

  fromDTO(dto: IPackageDTO, service: Service): PackageTemplate {
    const pckg = this.packageConstructor(dto, service);
    return pckg;
  }
}
